package devxertech.com.pages.industries.fintectIndustry.fintechServices

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.pages.commons.TeamService
import devxertech.com.theme.SitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span

@Composable
fun FintechServices(breakpoint: Breakpoint,
                     sitePalette: SitePalette){
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = if (breakpoint > Breakpoint.MD) 60.px else 55.px,
                bottom = if (breakpoint < Breakpoint.MD) 10.px else 50.px),
        contentAlignment = Alignment.Center
    ) {
        Column(
            verticalArrangement = Arrangement.Center,
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            FieldTitleTextNormalSimple(
                "FINANCIAL SOFTWARE DEVELOPMENT SERVICES WE OFFER ",
                asH2 = true,
                color = sitePalette.commonSecondaryButtonColor.rgb,
                fontSize = if (breakpoint > Breakpoint.MD) 18.px else 15.px,
                textAlign = TextAlign.Center,
                paddingLeft = 10.px,
                paddingRight = 10.px
            )
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Span(attrs = Modifier.fillMaxWidth().display(if (breakpoint < Breakpoint.MD)DisplayStyle.Contents else DisplayStyle.Flex)
                    .flexDirection(if (breakpoint <= Breakpoint.LG) FlexDirection.Column else FlexDirection.Row).toAttrs()) {
                FieldTitleTextNormalSimple(
                    "SEAMLESS, SMART, AND UNIQUELY ",
                    color = sitePalette.commonSecondaryButtonColor.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700
                )
                FieldTitleTextNormalSimple(
                    " PERSONALIZED",
                    color = sitePalette.primary.rgb,
                    fontFamily = Constants.ROBOTO_FONT,
                    fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                    fontWeight = 700
                )
            }
            }
            Row(
                modifier = Modifier.fillMaxWidth()
                    .padding(bottom = if (breakpoint < Breakpoint.MD) 0.px else if (window.screen.width > 1600) 10.px else 0.px,
                        top = if (breakpoint < Breakpoint.MD) 0.px else 40.px)
                    .flexWrap(FlexWrap.Wrap),
                horizontalArrangement = Arrangement.Center
            ) {
                TeamService(
                    image = Res.Image.fintech_1,
                    title = "Digital Payment Solutions",
                    description = "Devxer provides high-end yet reliable digital payment solutions to financial enterprises and " +
                            "companies so that they can create a strong technological footprint and can leverage the use of latest technological advancements like digital wallets, money transfer, online banking options and etc.",
                )
                TeamService(
                    image = Res.Image.fintech_2,
                    title = if (breakpoint <= Breakpoint.MD) "Data Security \n Systems" else "Data Security Systems" ,
                    description = "Data is the most valuable asset for any entity to grow and thrive and therefore, Devxer provides " +
                            "authentic and result-oriented data security solutions so each piece of financial information and related data is protected and safely stored.",
                )
                TeamService(
                    image = Res.Image.fintech_3,
                    title = "AI-Supported Platforms",
                    description = "AI-supported app development and web development is also offered by devxer as we realize the importance " +
                            "of artificial intelligence and big data solutions to gain better insights and make informed decisions regarding financial operations and framework.we also leverage the power of cloud-based integration.",
                )
                if (window.screen.width < 1600) {
                    TeamService(
                        image = Res.Image.fintech_4,
                        title = "Blockchain Technology",
                        description = " Modern day world is blockchain-affiliated and our team utilizes the Blockchain technology for " +
                                "providing fast and automated systems for cross-border payments, trading, identity management, and crypto currency operations.",
                    )
                    TeamService(
                        image = Res.Image.fintech_5,
                        title = "Customized Software \n" +
                                "Development",
                        description = "Our on-demand and customized software development services enables your idea to be showcased " +
                                "fully along with enhancing the software’s functionality, efficiency and user experience.",


                    )
                }
            }
            if (window.screen.width > 1600) {
                Row(modifier = Modifier.fillMaxWidth()
                    .display(DisplayStyle.Flex)
                    .flexWrap(FlexWrap.Wrap),
                    horizontalArrangement = Arrangement.Center
                ) {
                    TeamService(
                        image = Res.Image.fintech_4,
                        title = "Blockchain Technology",
                        description = " Modern day world is blockchain-affiliated and our team utilizes the Blockchain technology for " +
                                "providing fast and automated systems for cross-border payments, trading, identity management, and crypto currency operations.",
                    )
                    TeamService(
                        image = Res.Image.fintech_5,
                        title = "Customized Software \n" +
                                "Development",
                        description = "Our on-demand and customized software development services enables your idea to be showcased " +
                                "fully along with enhancing the software’s functionality, efficiency and user experience.",

                    )
                }
            }
        }
    }
}
